import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@lensora/ui/styles/globals.css'
import '@lensora/ui/themes/default.css'

import { App } from './app'

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
